import messages from './messages/drainerGroovesMessages';
import DrainerGroovesImage from './images/sinks/Sink_DrainerGrooves.png';
import NoDrainerGroovesImage from './images/sinks/Sink_NoDrainerGrooves.png';

export function generateDrainerGrooves() {
  return [
    {
      id: 'none',
      displayName: messages.none,
      displayImage: NoDrainerGroovesImage,
    },
    {
      id: 'drainer-grooves',
      displayName: messages.drainerGrooves,
      displayImage: DrainerGroovesImage,
    },
  ];
}
